import React from 'react';

import { BaseLink } from './Link.styles';
import { LinkProps } from './Link.types';

export function Link({ children, disabled = false, ...props }: LinkProps) {
  return (
    <BaseLink disabled={disabled} {...props}>
      {children}
    </BaseLink>
  );
}
